<template>
  <div id="EdicionProcesadoTemporalidad_div">
    <div id="encabezado-" class="form-inline justify-content-between">
      <h5>{{tituloDeInformacion}}</h5>
    </div>
    <hr class="mt-2" />
    <div >
      

        

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Temporalidad</h6>
          <C009TiposTemporalidad 
             
            v-on:valorParaElPadre="cambioDeTemporalidad" 
            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
            :idDelInput="'catalogoTiposTemporalidad'" 
            :parametros="{TipoTemporalidadId: null,ConInactivos: false}" 
            :valorDefinido="temporalidadId">
          </C009TiposTemporalidad>
        </div>




      
    <!-- Botones guardar y cancelar -->
    <div class="d-flex row">
        <div  class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-2 text-left">
            
             <button type="button" v-if="camposLlenos()" class="btn btn-success overwrapDeBotones mr-3"  @click="GuardarEdicionProcesadoTemporalidad()"><i class="fas fa-save fa-lg"></i>&nbsp;&nbsp;Guardar</button>

             <button type="button" class="btn btn-danger overwrapDeBotones mr-3"  @click="Botoncancelar()"><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Cancelar</button>

        </div>


        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
        
    </div>



  </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'

  Vue.use(VueMask);

  export default {
    data() {
      return {
        togglePerspectivaRender: 1,
        enumeraciones,
        tipoEstatusFirmaId:-1,
        partidoJudicialId: -1,
        materiaId: -1,
        delitoId: -1,
        rubroId: -1,
        areaId: -1,
        tipoDocumentoId: -1,
        entidadFederativaId: -1,
        municipioId: -1,
        temporalidadId: -1,
        nombre:null,
        apellido_paterno: null,
        apellido_materno: null,
        direccion: null,
        consecutivo: null,
        
       }  
              

    },
    props: {
      esAlta:true,
      tituloDeInformacion: String,
      EdiciondeProcesadosTemporalidad:Object
    },
    components: {
      C008TiposEstatusFirma: catalogos.SIVAC.C008TiposEstatusFirma,
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C008Delitos: catalogos.PJ.C008Delitos,
      C006TiposRubro: catalogos.SIVAC.C006TiposRubro,
      C010Municipios: catalogos.PJ.C010Municipios,
      C011EntidadesFederativas: catalogos.PJ.C011EntidadesFederativas,
      C009TiposTemporalidad: catalogos.SIVAC.C009TiposTemporalidad,
    },
    /**
     * Método encargado de cargar valores predetermidados en caso de haberlos.
     */
    beforeMount() { 

      
      

      if(this.EdiciondeProcesadosTemporalidad.TipoTemporalidadId)
        this.temporalidadId = this.EdiciondeProcesadosTemporalidad.TipoTemporalidadId;

     

      
    },
    methods: {
     
      /** 
       * Metodo encargado de obtener el valor del item seleccionado en el catalogo 007TiposEstatusFirma
       * @param {object} evento [evento emitido por el catalogo]
       */
     

      cambioDeTemporalidad: function (evento) {
        this.temporalidadId = parseInt(evento.target.value);
      },

      




      /** 
       * Método encargado de llamar API para obtener id's de los tipos de documentos disponibles dependiendo de la base de datos.
       */
      obtenerFiltradoTipoDeDocumentosAPI()
      {
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          MateriaId: this.parametros_Materia.materiaId,
          AreaId: this.parametros_Area.areaId,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            api.conexion + api.SIVAC.sistema.administracion.firmas.ObtenerTiposDeDocumentosIdYDBId, 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) 
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else 
            {
              this.parametros_TipoDocumento.parametros.elementosAConservar = respuesta.data.TiposDeDocumentosIds;
              this.baseDeDatosId = respuesta.data.BaseDeDatosId;
              this.parametros_TipoDocumento.key = "elementosAConservar_" + respuesta.data.TiposDeDocumentosIds.length;
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },     
      




/////////////////////////////////////////////////////////////////////////////////////////

      /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        
        
        if (!this.temporalidadId || this.temporalidadId <= 0) 
          return false;

        


        
        return true;


        // if (!this.apellido_paterno || this.apellido_paterno <= 0) 
        //   return false;

        // if (!this.apellido_materno || this.apellido_materno <= 0) 
        //   return false;






      },
      
      
      /**
       * Función encargada de verificar que el campo proporcionado tenga un valor valido.  
       * @param {string/int/other} campo 
       */
      campoRequeridoEsValido: function(campo) {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      
      /**
       * Función encargada de llamar a API para guardar una EdiciondeProcesadosTemporalidad
       */
      GuardarEdicionProcesadoTemporalidad:function()
      {

        var locale = {
        OK: '<i class="fa fa-check"></i>&nbsp;&nbsp;OK',
        CONFIRM: '<i class="fa fa-check"></i>&nbsp;&nbsp;Guardar',
        CANCEL: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
         };
            
       bootbox.addLocale('custom', locale);




          bootbox.prompt({
            title: "Mensaje del sistema",
            message: "Está por guardar la edición de la temporalidad del procesado, si decide continuar se guardara la edición para el Procesado. <br> <br> Nota: si se realizo la modificación de la temporalidad no es necesario generar una nueva firma, ya que las fechas de la ultima firma y proxima firma se dieron con la temporalidad anterior y hasta que vuelva a venir el procesado, se generara una nueva firma con la temporalidad nueva    <br> <br />Ingrese el motivo de la edición de la temporalidad del procesado: <br>",
            locale: 'custom',
            
            
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {
               this.$emit('guardar2', respuestaContinuar );
              }
            }
          });



      },



      Botoncancelar:function()
      {

       
     
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por cancelar la edición de la temporalidad del procesado.<br />¿Desea continuar?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {

                this.$emit("botoncancelar2");

                if(respuestaContinuar){      


                }

                
              }
            }
          });


               

      }
      



    },
    computed: {
     
    }
  }
</script>
<style scoped>
  .contenedor-puntero {
    background: #212529;
    border-radius:2px;
    padding: 10px;
    border:1px solid white;
    margin-bottom: 1.5em;
  }
  .form-control:disabled, .form-control[readonly]
  {
    background-color: #3D3C40 !important;
    pointer-events: none;
    color: #aaa;
  }
  ul { 
    list-style: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .contenedor-color-gris {        
        background-color: #9ea1a3;
        /*box-shadow: 0px 6px 20px 8px #161616;*/
        padding: 25px
    }

  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }  
</style>



// WEBPACK FOOTER //
// src/components/SIVAC/Firmas/EdicionProcesadoTemporalidad.vue